// components/Footer.js

"use client";
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EnvelopeIcon, MapPinIcon } from '@heroicons/react/24/solid';

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="bg-gray-800 text-white py-12">
      {/* Container with Responsive Horizontal Padding */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-0 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* About Section */}
        <div>
          <h3 className="text-xl font-bold mb-4">About Propertise AI Group</h3>
          <p>
            Improving Decision-Making in Australia’s $10 Trillion Residential Property Market with AI and LiDAR Technologies
          </p>
        </div>

        {/* Contact Information */}
        <div>
          <h3 className="text-xl font-bold mb-4">Contact Us</h3>
          <ul>
            <li className="mb-2 flex items-center">
              <EnvelopeIcon className="h-5 w-5 mr-2" />
              <span>info@propertiseaigroup.com.au</span>
            </li>
            <li className="mb-2 flex items-center">
              <MapPinIcon className="h-5 w-5 mr-2" />
              <span>Perth, Western Australia 6000</span>
            </li>
          </ul>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-bold mb-4">Quick Links</h3>
          <ul>
            <li className="mb-2">
              <a href="/privacy-policy" className="hover:underline">
                Privacy Policy
              </a>
            </li>
            <li className="mb-2">
              <a href="/terms-of-service" className="hover:underline">
                Terms of Service
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="mt-8 text-center">
        <p>&copy; 2024 Propertise AI Group. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
